import { useFormik } from "formik";
import { useEffect, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  Col,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Progress,
  Spinner,
} from "reactstrap";
import * as Yup from "yup";
import {
  CONFIG_OPTION_TOAST_ERROR,
  CONFIG_OPTION_TOAST_NORMAL,
} from "common/toast";
import {
  COLOR_HASHTAG_STATUS,
  HASHTAG_STATUS_OPTION,
} from "helpers/constans";
import DropdownStatusNew from "components/Common/DropdownStatusNew";
import { ColorPicker } from "antd";
import Keywords from "components/Common/Keywords";
import hashTagApi from "api/hashTagApi";

export default function HashTagForm({
  setIsOpen,
  item,
  setItemToEdit,
  loadTableData,
}: any) {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState<boolean>(false);
    const [isFirstProgress, setIsFirstProgress] = useState<boolean>(true);
  
  const isEdit = item;

  const handleSubmit = async (values: any) => {
    try {
      setIsLoading((_prev) => false);
      let data = {
        name: values?.name,
        status: values?.status,
        name_color: values?.name_color,
        active_text_color: values?.active_text_color,
        active_background_color: values?.active_background_color,
        normal_text_color: values?.normal_text_color,
        normal_background_color: values?.normal_background_color,
        hashtags: values?.hashtags
      }

      const response: any = isEdit
        ? await hashTagApi?.putHashTag(item?.id, data)
        : await hashTagApi?.postHashTag(data);

      if (response?.data) {
        //  dispatch(onGetPosts(query));
        loadTableData();
        setIsLoading((_prev) => false);
        setIsOpen(false);
        toast(
          `${t("The process has been completed.")}`,
          CONFIG_OPTION_TOAST_NORMAL
        );
      } else {
        setIsLoading(false);
        toast(`${response}`, CONFIG_OPTION_TOAST_ERROR);
      }
    } catch (error: any) {
      setIsLoading(false);
      toast(error);
      return error;
    }
  };

  const validationSchema = Yup.object({
    name: Yup.string().required(`${t("This field is required")}`),
    name_color: Yup.string().required(`${t("This field is required")}`),
    hashtags: Yup.array()
      .min(1, `${t("This field is required")}`)
      .required(`${t("This field is required")}`),
  });

  const formik = useFormik({
    initialValues: {
      name: "",
      name_color: "#333333",
      normal_text_color: "#333333",
      normal_background_color: "#f5f5f5",
      active_text_color: "#ffffff",
      active_background_color: "#4a4a4a",
      status: '1',
      hashtags: []
    },
    validationSchema,
    onSubmit: handleSubmit,
  });

  const initialValueHashTag =
    (formik?.values?.hashtags?.map((item: any) => ({
      id: item?.toLowerCase(),
      text: item,
    })) as any) || [];

  const onCloseClick = () => {
    setIsOpen(false);
    setItemToEdit(false);
  };

  useEffect(() => {
    if (item) {
      formik.setValues(item)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [item]);

  useEffect(() => {
    if(Object.keys(formik.errors).length > 0) {
      setIsFirstProgress(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [Object.keys(formik.errors).length]) 

  return (
    <Modal isOpen={true} centered={true} scrollable={false} size="lg">
      <ModalHeader toggle={isLoading ? () => {} : onCloseClick}>
        {isEdit ? t("Button Update Hashtag") : t("Button Create Hashtag")}
      </ModalHeader>
      <ModalBody className="py-3 px-4">
        <div className="mb-4">
          <Progress
            value={
              ((!isFirstProgress || !!isEdit) ? 100 - (100 / 3) * Number(Object.keys(formik.errors).length) : 0)
            }
            color="primary"
            className="animated-progress progress-sm"
          />
        </div>
        <form onSubmit={formik.handleSubmit}>
          <div className="row g-3">
            <Col lg={4}>
              <div className="mb-1">
                <Label htmlFor="name-bar" className="form-label">
                  {t("Group Name")} <span className="text-danger"> *</span>
                </Label>
                <Input
                  name="name"
                  type="text"
                  className="form-control"
                  placeholder={t("Enter your group name")}
                  value={formik?.values?.name}
                  onChange={(event) => formik.setFieldValue("name", event?.target?.value)}
                />
                {formik.touched.name && formik.errors.name ? (
                  <div className="text-danger mt-2">
                    {formik.errors.name}
                  </div>
                ) : null}
              </div>
            </Col>

            <Col lg={4}>
              <label className="form-label w-100">
                {`${t("Name Color")}`} <span className="text-danger"> *</span>
              </label>
              <ColorPicker
                defaultValue="#1677ff"
                showText
                allowClear
                onChange={(value) => {
                  // formik.setFieldValue(`color`, value)
                  let color = typeof value == "string"
                  ? value
                  : value?.toHexString()
                  formik.setFieldValue(`name_color`, color)
                }}
                value={formik.values?.name_color}
              />{" "}
              {formik.touched.name_color && formik.errors.name_color ? (
                <div className="text-danger mt-2">{formik.errors.name_color}</div>
              ) : null}
            </Col>

            <Col lg={4}>
              <label className="form-label">
                {t("Status")}
              </label>

              <DropdownStatusNew
                name="status"
                dataList={HASHTAG_STATUS_OPTION || []}
                placeholder={`${t("Status")}...`}
                className="dropdown-status-rounded"
                classNamePrefix="name-prefix"
                initialValue={formik.values.status}
                onChangeSelect={(event: any) => {
                  formik.setFieldValue("status", event?.value);
                }}
                isHasOptionAll={false}
                colors={COLOR_HASHTAG_STATUS}
              />

              {formik.touched.status && formik.errors.status ? (
                <div className="text-danger mt-2">
                  {formik.errors.status}
                </div>
              ) : null}
            </Col>

            <Col xxl={12}>
              <label style={{marginBottom: 0}}>
                {t("Normal State Color")}
              </label>
            </Col>

            <Col xxl={4} className="mt-2">
              <label className="form-label w-100">
                {`${t("Text Color")}`} <span className="text-danger"> *</span>
              </label>
              <ColorPicker
                defaultValue="#1677ff"
                showText
                allowClear
                onChange={(value) => {
                  // formik.setFieldValue(`color`, value)
                  let color = typeof value == "string"
                  ? value
                  : value?.toHexString()
                  formik.setFieldValue(`normal_text_color`, color)
                }}
                value={formik.values?.normal_text_color}
              />{" "}
              {formik.touched.normal_text_color && formik.errors.normal_text_color ? (
                <div className="text-danger mt-2">{formik.errors.normal_text_color}</div>
              ) : null}
            </Col>

            <Col xxl={4} className="mt-2">
              <label className="form-label w-100">
                {`${t("Background Color")}`} <span className="text-danger"> *</span>
              </label>
              <ColorPicker
                defaultValue="#1677ff"
                showText
                allowClear
                onChange={(value) => {
                  // formik.setFieldValue(`color`, value)
                  let color = typeof value == "string"
                  ? value
                  : value?.toHexString()
                  formik.setFieldValue(`normal_background_color`, color)
                }}
                value={formik.values?.normal_background_color}
              />{" "}
              {formik.touched.normal_background_color && formik.errors.normal_background_color ? (
                <div className="text-danger mt-2">{formik.errors.normal_background_color}</div>
              ) : null}
            </Col>

            <Col xxl={4} className="mt-2">
              <label className="form-label w-100">
                {`${t("Preview")}`}
              </label>
              <div>
                {
                  (formik?.values?.normal_text_color || formik?.values?.normal_background_color) && (
                    <span
                      style={{
                        color: formik?.values?.normal_text_color,
                        backgroundColor: formik?.values?.normal_background_color,
                        padding: "4px",
                        borderRadius: "10px"
                      }}
                    >
                      #{formik?.values?.name ? formik?.values?.name : 'preview'}
                    </span>
                  )
                }
              </div>
            </Col>

            <Col xxl={12}>
              <label style={{marginBottom: 0}}>
                {t("Selected State Color")}
              </label>
            </Col>

            <Col xxl={4} className="mt-2">
              <label className="form-label w-100">
                {`${t("Text Color")}`} <span className="text-danger"> *</span>
              </label>
              <ColorPicker
                defaultValue="#1677ff"
                showText
                allowClear
                onChange={(value) => {
                  // formik.setFieldValue(`color`, value)
                  let color = typeof value == "string"
                  ? value
                  : value?.toHexString()
                  formik.setFieldValue(`active_text_color`, color)
                }}
                value={formik.values?.active_text_color}
              />{" "}
              {formik.touched.active_text_color && formik.errors.active_text_color ? (
                <div className="text-danger mt-2">{formik.errors.active_text_color}</div>
              ) : null}
            </Col>

            <Col xxl={4} className="mt-2">
              <label className="form-label w-100">
                {`${t("Background Color")}`} <span className="text-danger"> *</span>
              </label>
              <ColorPicker
                defaultValue="#1677ff"
                showText
                allowClear
                onChange={(value) => {
                  // formik.setFieldValue(`color`, value)
                  let color = typeof value == "string"
                  ? value
                  : value?.toHexString()
                  formik.setFieldValue(`active_background_color`, color)
                }}
                value={formik.values?.active_background_color}
              />{" "}
              {formik.touched.active_background_color && formik.errors.active_background_color ? (
                <div className="text-danger mt-2">{formik.errors.active_background_color}</div>
              ) : null}
            </Col>

            <Col xxl={4} className="mt-2">
              <label className="form-label w-100">
                {`${t("Preview")}`}
              </label>
              <div>
                {
                  (formik?.values?.active_text_color || formik?.values?.active_background_color) && (
                    <span
                      style={{
                        color: formik?.values?.active_text_color,
                        backgroundColor: formik?.values?.active_background_color,
                        padding: "4px",
                        borderRadius: "10px"
                      }}
                    >
                       #{formik?.values?.name ? formik?.values?.name : 'preview'}
                    </span>
                  )
                }
              </div>
            </Col>

            <Col lg={12}>
              <div className="mb-3">
                <Label className="form-label">{t("Hashtag")}<span className="text-danger"> *</span></Label>

                <Keywords
                  name="hashtags"
                  placeholder={`${t("Enter your hashtag")}...`}
                  suggestions={[]}
                  initialValue={initialValueHashTag}
                  textColor={formik?.values?.normal_text_color}
                  bgColor={formik?.values?.normal_background_color}
                  isChangeSelectedColor={true}
                  onChangeTag={(event) => {
                    const keywords = event?.map((item) => item.text);
                    formik.setFieldValue("hashtags", keywords);
                  }}
                />

                {formik?.touched?.hashtags && formik?.errors?.hashtags ? (
                  <div className="text-danger mt-2">
                    {formik?.errors?.hashtags}
                  </div>
                ) : null}
              </div>
            </Col>

            <div className="col-lg-12">
              <div className="hstack gap-2 justify-content-end">
                <button
                  className="btn btn-primary fs-14"
                  color="success"
                  type="submit"
                  disabled={isLoading}
                  style={{ width: "120px" }}
                >
                  {isLoading ? (
                    <Spinner size="sm" className="me-2"></Spinner>
                  ) : (
                    <>{isEdit ? t("Button Update") : t("Button Create")}</>
                  )}
                </button>
              </div>
            </div>
          </div>
        </form>
      </ModalBody>
    </Modal>
  );
}
